import styled from "styled-components";
import colors from "../../../../styles/colors";

export const Container = styled.div`
  margin-bottom: 15px;
`;

export const NoticeBox = styled.div`
  background-color: ${colors.warningBgLight};
  border: 1px solid ${colors.warningBorder};
  border-left: 4px solid ${colors.warningBorderDark};
  border-radius: 6px;
  padding: 12px 16px;
  color: ${colors.warningText};
  line-height: 1.5;

  p {
    margin: 8px 0;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  strong {
    font-weight: 600;
  }
`;
